interface BrandMarkProps {
  tone?: "dark" | "light";
  compact?: boolean;
}

export default function BrandMark({ tone = "dark", compact = false }: BrandMarkProps) {
  void tone;
  void compact;

  return (
    <span className="flex items-center">
      <img
        src="https://a1.bumerangbil.com/assets/img/dmar_logo.png"
        alt="d.mar Dental Görüntüleme Merkezi logosu"
        style={{ width: "10.5rem" }}
        className="h-auto shrink-0 object-contain"
      />
    </span>
  );
}